<template>
  <v-layout
    wrap
    align-center
  >
    <v-flex
      v-if="getUser && (getUser.pack == 'Premium' || getUser.pack == 'VIP')"
      xs12
      mb-4
    >
      <v-flex
        class="d-flex"
        xs12
      >
        <v-menu
          offset-y
          right
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="$apollo.loading"
              outlined 
              small
              text
              v-on="on"
            >
              {{ params.filter != 'UNLINKED' ? $t('rankings.common') : $t('rankings.unlinked') }}
            </v-btn>
          </template>
          <v-sheet dense>
            <v-list-item
              @click="reload('NEW')"
            >
              <v-list-item-title>{{ $t('rankings.common') }}</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item
              @click="reload('NEW','ADVANCED')"
            >
              <v-list-item-title>{{ $t('rankings.advanced') }}</v-list-item-title>
            </v-list-item> -->
            <v-list-item
              @click="reload('NEW','UNLINKED')"
            >
              <v-list-item-title>{{ $t('rankings.unlinked') }}</v-list-item-title>
            </v-list-item>
          </v-sheet>
        </v-menu>
        <v-btn
          class="ml-2"
          small
          text
          outlined
          :loading="$apollo.loading && action != 'ADD'"
          :disabled="$apollo.loading"
          @click="reload('RELOAD')"
        >
          <v-icon>mdi-reload</v-icon>
        </v-btn>
      </v-flex>
      <v-skeleton-loader
        v-if="$apollo.loading && action == 'NEW'"
        type="table-tbody"
        :tile="true"
        class="mx-auto"
        width="100%"
      />
      <v-data-table
        v-if="!$apollo.loading || projectInvestorPerformance && action != 'NEW'" 
        class="accounts text-no-wrap" 
        :headers="headers"
        :locale="$i18n.locale"
        :items="projectInvestorPerformance.data"
        :items-per-page="projectInvestorPerformance.total"
        :hide-default-footer="true"
        no-data-text=""
        dense
      >
        <template v-slot:header.current_upnl_ptc="{ }">
          <span>{{ $t('rankings.upnl') }}</span> 
          <template>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('rankings.upnlPerInvestor') }}
            </v-tooltip>
          </template>
        </template> 
        <template v-slot:header.trailing_stop_ptc="{ }">
          <span>{{ $t('rankings.trailingStop') }}</span> 
          <template>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  style="padding: 3px;"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('rankings.trailingStopTooltip') }}
            </v-tooltip>
          </template>
        </template>   
        <template v-slot:header.allowed_drawdown_ptc="{ }">
          <span>{{ $t('rankings.riskAndLot') }}</span> 
          <template>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  style="padding: 3px;"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('rankings.riskAndLotTooltip') }}
            </v-tooltip>
          </template>
        </template>   
        <template
          slot="headerCell"
          slot-scope="{ header }"
        >
          <span
            v-text="header.text"
          /> 
        </template>
        <template v-slot:item.id="{ item }">
          <div class="d-flex flex-row">
            <div
              style="min-width:100px;"
            >
              <span>
                {{ item.connection_id }}
              </span>
            </div>
            <v-tooltip
              v-if="item.current_balance > 0.005 && ((item.avg_deposit / item.init_deposit ) - 1) * 100 >= item.allowed_drawdown_ptc"
              top
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  class="text-positive"
                  style="margin: -2px 7px 0px; font-size:18px;"
                  v-on="on"
                >
                  mdi-shield-check
                </v-icon>
              </template>
              {{ $t('rankings.investorSave') }}
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.pnl_this_month_ptc="{ item }">
          <b :class="colorPnL(item.pnl_this_month_ptc)">{{ item.pnl_this_month_ptc }}%</b>
        </template>
        <template v-slot:item.trailing_stop_ptc="{ item }">
          <b class="text-neutral">{{ item.trailing_stop_ptc }}%</b>
        </template>
        <template v-slot:item.current_upnl_ptc="{ item }">
          <b :class="colorPnL(item.current_upnl_ptc)">{{ item.current_upnl_ptc }}%</b>
        </template>
        <template v-slot:item.pnl_total_ptc="{ item }">
          <div style="display:flex;flex-direction: row">
            <b
              style="min-width:45px;"
              :class="colorPnL(item.pnl_total_ptc)"
            >{{ item.pnl_total_ptc }}%</b>
          </div>
        </template>
        <template v-slot:item.allowed_drawdown_ptc="{ item }">
          {{ item.allowed_drawdown_ptc }}% (1:{{ item.risk_ratio }})
        </template>
        <template v-slot:item.current_balance="{ item }">
          <b>
            {{ item.base_currency | renderSymbol }} 
            {{ item.status !== 'disconnected' ? item.current_balance : 0 }}
          </b>
        </template>
        <template v-slot:item.connected_at="{ item }">
          <span v-if="params.filter != 'UNLINKED'">{{ item.connected_at | moment('L') }}</span>
          <span v-else> - </span>
        </template>
      </v-data-table>
      <center>
        <v-btn
          v-if="projectInvestorPerformance && projectInvestorPerformance.last_page > params.page"
          class="mt-5"
          small
          text
          outlined
          :loading="$apollo.loading && action == 'ADD'"
          :disabled="$apollo.loading"
          @click="reload('ADD')"
        >
          {{ $t('rankings.more') }}
          <v-icon
            right
            dark
          >
            mdi-arrow-down
          </v-icon>
        </v-btn>
      </center>
    </v-flex>
    <v-flex
      v-if="!$apollo.loading && projectInvestorPerformance && _.isEmpty(projectInvestorPerformance.data)"
      class="not-found"
      align-self-center
    >
      <v-icon>mdi-ghost</v-icon>
      <p>{{ $t('traderdashboard.accountsNotFound') }}</p>
    </v-flex>
  </v-layout>
</template>

<script>

const PROJECT_INVESTOR_PERFORMANCE_QUERY = require('@/graphql/queries/ProjectInvestorPerformance.gql');
import { mapGetters } from "vuex";

export default {
  name: 'InvestorPerfomrnce',
  
  props: {
    projectId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      upgradeDialog: false,
      emotion: false,
      action: 'NEW',
      showMore: true,
      params: {
        id: this.projectId,
        page: 0,
        count: 20
      },
      loading: false,
      headers: [ 
        {
          sortable: false,
          text: this.$t('investors.investor'),
          value: 'id'
        },  
        {
          sortable: false,
          text: this.$t('globals.pnl_this_month'),
          value: 'pnl_this_month_ptc',
        },
        {
          sortable: false,
          text: this.$t('globals.pnl_total'),
          value: 'pnl_total_ptc',
        },
        {
          sortable: false,
          text: this.$t('rankings.upnl'),
          value: 'current_upnl_ptc'
        },
        {
          sortable: false,
          text: this.$t('rankings.trailingStop'),
          value: 'trailing_stop_ptc'
        },
        {
          sortable: false,
          text: this.$t('rankings.riskAndLot'),
          value: 'allowed_drawdown_ptc'
        },
        {
          sortable: false,
          text: this.$t('globals.aum'),
          value: 'current_balance'
        },
         {
          sortable: false,
          text: this.$t('rankings.dateStart'),
          value: 'connected_at'
        },
      ]
    }
    
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("invoice", ["getPending"]),
  },
  methods: {
    reload(action, filter) {
      this.action = action
      if (action == 'ADD') {
        this.params.page += 1
      }
      
      if (action == 'NEW' || action == 'RELOAD') {
       if (!filter || action == 'RELOAD') {
          this.params.page = 0
          delete(this.params.filter)
        } else if (filter != null) {
          this.params.page = 0
          this.params.filter = filter
        }
      }
      
      this.$apollo.queries.projectInvestorPerformance.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          
          if (action == 'NEW' || action == 'RELOAD') {
            return fetchMoreResult
          }
    
          const newData = fetchMoreResult.projectInvestorPerformance.data
    
          return {
            projectInvestorPerformance: {
              __typename: previousResult.projectInvestorPerformance.__typename,
              data: [...previousResult.projectInvestorPerformance.data, ...newData],
              current_page: this.projectInvestorPerformance.current_page,
              per_page: this.projectInvestorPerformance.per_page,
              last_page: this.projectInvestorPerformance.last_page,
              total: this.projectInvestorPerformance.total,
            },
          }
        },
      })
    },
    closeUpgradeDialog() {
      this.upgradeDialog = false
      if (this.getPending != null) {
        this.$router.push(`/invoice/${this.getPending}`)
      }
    }
  },
  apollo: {
    projectInvestorPerformance: {
      query: PROJECT_INVESTOR_PERFORMANCE_QUERY,
      skip() {
        return !this.getUser || this.getUser.pack == null
      },
      variables() {
        return this.params
      },
      fetchPolicy: 'network-only'
    }
  },
}
</script>

<style lang="scss" scoped>
  th {
    .v-icon {
      margin-top:-2px;
      margin-left:4px;
      font-size: 16px;
    }
  }
  .performance_note {
    margin: 20px 8px 0;
    display: block;
    color: #7f97ab;
    font-size: 0.78rem;
    i {
      font-size: 0.95rem;
    }
  }
  .upgrade-pack {
    background-image: url("/img/inv-stats.png");
    background-repeat: no-repeat;
    background-size: cover;
  }
  

</style>
